import React from 'react'
import { styled } from '@mui/material/styles'
import { Avatar, Card, CardContent, Grid, Link, Typography } from '@mui/material/'
import { ArticleFragment } from '@services/graphcms/client'
import { StyledAuthor } from './StyledAuthor'

const PREFIX = 'Author'

const classes = {
  avator: `${PREFIX}-avator`,
  title: `${PREFIX}-title`,
  titleLink: `${PREFIX}-titleLink`,
}

const StyledCard = styled(Card)(({ theme }) => ({
  [`& .${classes.avator}`]: {
    height: theme.spacing(8),
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: theme.spacing(8),
  },

  [`& .${classes.title}`]: {
    fontWeight: 550,
  },

  [`& .${classes.titleLink}`]: {
    fontWeight: 550,

    '&:hover': {
      textDecoration: 'underline',
    },
  },
}))

type Props = {
  article: ArticleFragment
}

export function Author(props: Props) {
  if (!props.article.author) {
    return null
  }

  return (
    <StyledCard elevation={0} variant="outlined">
      <CardContent>
        <Grid container={true} alignItems="center">
          {props.article.author.thumbnail && props.article.author.thumbnail.url && (
            <Avatar
              alt={props.article.author.name}
              src={props.article.author.thumbnail.url}
              className={classes.avator}
            />
          )}
          {props.article.author.link ? (
            <Typography className={classes.titleLink} variant="h6">
              <Link color="textPrimary" href={props.article.author.link} underline="hover">
                {props.article.author.name}
              </Link>
            </Typography>
          ) : (
            <Typography className={classes.title} variant="h6">
              {props.article.author.name}
            </Typography>
          )}
        </Grid>
        {props.article.author.description?.html && (
          <StyledAuthor
            dangerouslySetInnerHTML={{
              __html: props.article.author.description.html,
            }}
          />
        )}
      </CardContent>
    </StyledCard>
  )
}
